import { Component, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { PopupMessages } from "src/app/backend/popup-message";
import { AnnouncementService } from "src/app/services/announcement/announcement.service";
import { LoadingService } from "src/app/services/loading/loading.service";
import { PopupMessageService } from "src/app/services/popup-message/popup-message.service";
import { CreateAnnouncementForm } from "../../forms/create-announcement-form";
import { Center } from "src/app/models/centers/center";

@Component({
  selector: "app-announcement-create-page",
  templateUrl: "./announcement-create-page.component.html",
  styleUrls: ["./announcement-create-page.component.scss"],
})
export class AnnouncementCreatePageComponent implements OnInit {
  minDate: Date = new Date();
  form: CreateAnnouncementForm = this.announcementService.form;

  constructor(
    private announcementService: AnnouncementService,
    private loadingService: LoadingService,
    private popupMessageService: PopupMessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  openURL(): void {
    if (this.url.value == null) return;
    window.open(this.url.value);
  }

  submit(): void {
    if (this.recipient.value == "Person") {
      this.form.centers = [];
    }
    if (this.recipient.value == "Center") {
      this.form.users = [];
    }

    if (
      this.form.formGroup.valid == false ||
      this.form.invalidExpireDate == true
    ) {
      this.form.formGroup.markAllAsTouched();
      this.popupMessageService.messageSignal.emit(
        PopupMessages.InvalidInformationMessage,
      );
      return;
    }

    if (
      (this.recipient.value == "Person" && this.form.users.length == 0) ||
      (this.recipient.value == "Center" && this.form.centers.length == 0)
    ) {
      this.popupMessageService.messageSignal.emit(
        PopupMessages.EmptyRecipientErrorMessage,
      );
      return;
    }

    this.loadingService.startLoading();
    this.announcementService
      .createAnnouncement(this.form.getCreateAnnouncementModel())
      .pipe(finalize(() => this.loadingService.stopLoading()))
      .subscribe({
        next: (value) => {
          this.form.reset();
          this.popupMessageService.messageSignal.emit(
            PopupMessages.CreateAnnouncementSuccessMessage(
              new Observable<any>((subscriber) => {
                this.router.navigate(["/main/announcement/overview", value]);
              }),
            ),
          );
        },
      });
  }

  centerPopupAction: (centers: Center[]) => void = ((centers: Center[]) => {
    this.form.centers = centers;
  }).bind(this);

  get recipient(): AbstractControl {
    return this.form.formGroup.controls["recipient"];
  }

  get title(): AbstractControl {
    return this.form.formGroup.controls["title"];
  }

  get type(): AbstractControl {
    return this.form.formGroup.controls["type"];
  }

  get url(): AbstractControl {
    return this.form.formGroup.controls["url"];
  }

  get announceDate(): UntypedFormControl {
    return this.form.formGroup.controls["announceDate"] as UntypedFormControl;
  }

  get expireDate(): UntypedFormControl {
    return this.form.formGroup.controls["expireDate"] as UntypedFormControl;
  }
}
